export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./games-list.vue?vue&type=template&id=2d3991cb&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/games-list.vue?vue&type=template&id=2d3991cb&scoped=true
// module id = 97cp
// module chunks = 0